<!--
 * @Author: your name
 * @Date: 2021-05-20 11:07:43
 * @LastEditTime: 2021-06-04 10:54:28
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \VtpWechatUI\src\components\HelloWorld.vue
-->
<template>
    <div :model="model" style="background:#FAFAFA">
        <div class="weui-cells__title TitleClass" align="center" >审批信息</div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">申请状态：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.dispvisitorstate" class="weui-input" type="text" disabled placeholder="">
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells__title TitleClass" align="center" >被访人信息</div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell" align="left">
                <div class="weui-cell__hd" style="width:20%">
                    <label class="weui-label" prop="visitedname" style="float:left">姓名：</label>
                </div>
                <div class="weui-cell__bd" style="float:right">
                    <input v-model="model.visitedname" class="weui-input" type="text" required="required" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%">
                    <label class="weui-label" align="left" prop="visitedphonenum">电话：</label>
                </div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitedphonenum" class="weui-input" type="number"  disabled placeholder="">
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%">
                    <label class="weui-label" align="left" prop="visiteddeptfullname">部门：</label>
                </div>
                <div class="weui-cell__bd">
                    <input v-model="model.visiteddeptfullname" class="weui-input" type="text" style="font-size:14px" disabled placeholder="正确填写手机号后自动填充">
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells__title TitleClass" align="center">访客信息</div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">姓名：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitorname" class="weui-input" type="text" disabled placeholder="">
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">电话：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitorphonenum" class="weui-input" type="number" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">身份证号：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitoridcard" class="weui-input" type="text" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">所属单位： </label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitorcompony" class="weui-input" type="text" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">入园时间：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.estimateintoparktime" placeholder="时间格式2020-01-01 00:00" style="border:none;width:100%" type="primary" readonly />
                    <van-popup v-model="show" position="bottom">
                        <van-datetime-picker type="datetime" :min-date="minDate" :filter="vanDatetimePickerFilter" @confirm="saveTimeAction" @cancel="show= false" />
                    </van-popup>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">离园时间：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.estimateleavetime" placeholder="时间格式2020-01-01 00:00" style="border:none;width:100%" type="primary" readonly />
                    <van-popup v-model="show1" safe-area-inset-bottom position="bottom">
                        <van-datetime-picker type="datetime" :min-date="minDate" :filter="vanDatetimePickerFilter" @confirm="saveTimeEnd" @cancel="show1=false" />
                    </van-popup>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd"><label class="weui-label" align="left">来访事由：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.visitreason" class="weui-input" type="text" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells weui-cells_form">
            <div class="weui-cell">
                <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">车牌号：</label></div>
                <div class="weui-cell__bd">
                    <input v-model="model.carnumber" class="weui-input" type="text" placeholder="" disabled>
                </div>
            </div>
            <div class="weui-cell lineHeng">
            </div>
        </div>
        <div class="weui-cells__title TitleClass" align="center" v-if="lists.length > 0?true:false" >同行者信息</div>
        <div>
            <div v-for="(list) in lists" :key="list.index">
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd" style="width:20%">
                            <label class="weui-label" align="left">姓名：</label>
                        </div>
                        <div class="weui-cell__bd">
                            <input v-model="list.visitorname" class="weui-input" type="text" placeholder="" sytle="width:75%" disabled>
                        </div>
                    </div>
                    <div class="weui-cell lineHeng">
                    </div>
                </div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd" style="width:20%"><label class="weui-label" align="left">电话：</label></div>
                        <div class="weui-cell__bd">
                            <input v-model="list.visitorphonenum" class="weui-input" type="number" placeholder="" disabled>
                        </div>
                    </div>
                    <div class="weui-cell lineHeng">
                    </div>
                </div>
                <div class="weui-cells weui-cells_form">
                    <div class="weui-cell">
                        <div class="weui-cell__hd"><label class="weui-label" align="left">身份证号：</label></div>
                        <div class="weui-cell__bd">
                            <input v-model="list.visitoridcard" class="weui-input" type="text" placeholder="" disabled>
                        </div>
                    </div>
                    <div class="weui-cell lineHeng">
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { getAction, postAction } from '../request/http'
import store from '@/store/index'
import { Toast } from 'we-vue'
export default {
    name: 'HelloWorld',
    data() {
        return {
            show: false,
            show1: false,
            minDate: new Date(),
            model: {},
            screenWidth: document.body.clientWidth, // 屏幕宽
            datalist: [],
            lists: [],
            addPartnerBackGroundColor: 'white',
            pageInfo: {
                currentPage: 1, // 当前页面
                pageSize: 10,
                totalCount: 0, // 总数
                sord: 'desc',
                sidx: 'id'
            }
        }
    },
    computed: {

    },
    beforeCreate() {
        document.title = "入园申请"
    },
    created() {
    },
    mounted() {
        this.createmore()
    },
    methods: {
        vanDatetimePickerFilter(type, options) {
            if (type === 'minute') {
                return options.filter((option) => option % 10 === 0)
            }
            return options
        },
        createmore() {
          var id = this.$route.query.id
          var code = this.$route.query.code
          if (!id) {
              id = ''
          }
          if (!code) {
            code = ''
          }
          var data = {
            qry_id: id,
            code: code
          }
          postAction("/vtp/toaEnterParkUser/queryVisitorInfo", data).then((res) => {
            if (res.data.success) {
            this.model.visitedname = res.data.result.visitedname
            this.model.visitedphonenum = res.data.result.visitedphonenum
            this.model.visitorname = res.data.result.visitorname
            this.model.visitorphonenum = res.data.result.visitorphonenum
            this.model.visitoridcard = res.data.result.visitoridcard
            this.model.visitorcompony = res.data.result.visitorcompony
            this.model.visitreason = res.data.result.visitreason
            this.model.visiteddeptfullname = res.data.result.visiteddeptfullname
            this.model.carnumber = res.data.result.carnumber
            this.model.dispvisitorstate = res.data.result.dispvisitorstate
            this.model.estimateintoparktime = res.data.result.estimateintoparktime
            this.model.estimateleavetime = res.data.result.estimateleavetime
            this.lists = res.data.result.datalist
            //   that.lists = res.data.result.dataList
            // getAction("/vtp/toaEnterParkPartner/list", partnerdata).then((res) => {
            //   if (res.data.success) {
            //     this.lists = res.data.result.dataList
            //   }
            // })
            this.$forceUpdate()
            }
          })
        },
        timeAction(time) {
            const date = new Date(time)
            var seperator1 = "-"
            var seperator2 = ":"
            var month = date.getMonth() + 1
            var strDate = date.getDate()
            var hour = date.getHours()
            if (hour.toString().length === 1) {
                hour = '0' + hour
            }
            var minutes = date.getMinutes()
            if (minutes.toString().length === 1) {
                minutes = '0' + minutes
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate
            }
            const a =
                date.getFullYear() +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                seperator2 +
                minutes
            this.model.estimateintoparktime = a
        },
        saveTimeAction(val) {
            this.show = false
            this.timeAction(Date.parse(val))
        },
        timeFormatterEnd(time) {
            const date = new Date(time)
            var seperator1 = "-"
            var seperator2 = ":"
            var month = date.getMonth() + 1
            var strDate = date.getDate()
            var hour = date.getHours()
            var minutes = date.getMinutes()
            if (hour.toString().length === 1) {
                hour = '0' + hour
            }
            if (minutes.toString().length === 1) {
                minutes = '0' + minutes
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate
            }
            const a =
                date.getFullYear() +
                seperator1 +
                month +
                seperator1 +
                strDate +
                " " +
                hour +
                seperator2 +
                minutes
            this.model.estimateleavetime = a
        },
        saveTimeEnd(val) {
            this.show1 = false
            this.timeFormatterEnd(Date.parse(val))// 选择时间日期 2019-01-30
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#app .weui-cells_form span >>> .van-button {
    height: 100%;
}
weui-cells .link-top {
    width: 100%;
    height: 1px;
    border-top: solid #acc0d8 1px;
}
.bannercontainner {
    padding: 15px;
}
.gonggao {
    flex: 1;
    background-color: rgb(252, 104, 72);
    border-radius: 15px;
    height: 35px;
    line-height: 35px;
}
.banner {
    background-image: url('../assets/banner.jpg');
    background-size: 100% 100%;
}
.greeBack {
    background-color: green;
}
#app .weui-loading_toast >>> .weui-mask_transparent {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: #666666;
    opacity: 0.5;
}
.weui-mask_transparent {
    position: fixed;
    z-index: 1000;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
}
.gonggaocontent {
    flex: 4;
    height: 35px;
    text-align: left;
    line-height: 35px;
    text-indent: 15px;
}
.line {
    margin-top: 5px;
    background-color: rgb(246, 246, 246);
    height: 2px;
}
.linecontainer {
    padding-left: 10px;
    padding-right: 10px;
}
.enterParkApplyleftcontent {
    background-image: url('../assets/enterParkApply.jpg');
    background-size: 100% 100%;
    border-radius: 15px;
}
.allfunction {
    padding-top: 20px;
}
.enterParkApplyrightcontent1 {
    background-image: url('../assets/applyHistory.jpg');
    background-size: 100% 100%;
    margin-top: 10px;
    border-radius: 15px;
}
.enterParkApplyrightcontent2 {
    background-image: url('../assets/cancelApply.jpg');
    background-size: 100% 100%;
    margin-top: 10px;
    border-radius: 15px;
}
.enterParkApplycontainer {
    padding: 10px;
}
.enterParkApplyrightcontainer {
    padding-left: 0px;
    padding-right: 10px;
    padding-top: 0px;
}

#app div >>> .weui-cells::before {
    border: 0px;
}
#app div >>> .weui-cells::after {
    border: 0px;
}
#app div >>> .weui-cells {
    margin-top: 0px;
}
.lineHeng {
    margin-left: 5%;
    width: 90%;
    padding: 0px;
    border-top: 1px solid var(--weui-FG-3);
}
.TitleClass{
  background: #e7eaec;
  margin: 0 auto;
  height: 30px;
  padding-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/View.vue